"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jsxFileName = "/Users/john/Desktop/Projects/nq-component/src/InputIcon/IconItem.js";
function IconItem(_ref) {
  var data = _ref.data,
    innerRef = _ref.innerRef,
    innerProps = _ref.innerProps;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: "react-select p-2 pl-3 cursor-pointer",
    ref: innerRef
  }, innerProps, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 3,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("i", {
    className: data.value,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "ms-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 13
    }
  }, data.label));
}
var _default = exports["default"] = IconItem;